import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import styled from 'styled-components';

import logo from '../assets/images/quizrr-logo.svg';
import { getLanguageCode, useLocalizedSiteBottom } from '../utils';

import Block from './Block';
import Grid from './Grid';
import Cell from './Cell';
import HeaderLogo from './HeaderLogo';
import H5 from './H5';
import P from './P';
import Image from './Image';

const ContactAnchor = styled.a`
  color: ${({ theme }) => theme.colors.coral};
`;

const SocialLinkAnchor = styled.a`
  width: 25px;
`;

const SiteBottom = ({ selectedLocale }) => {
  const [siteBottom] = useLocalizedSiteBottom(selectedLocale);
  const content = siteBottom.node.data;

  return (
    <Block
      as="footer"
      backgroundColor="blueDark"
      py={{ mobile: 'baseUp4', tablet: 'baseUp8' }}
    >
      <Grid>
        <Cell size={{ mobile: 1, tablet: 1 / 2 }}>
          <Block
            display="flex"
            justifyContent={{ mobile: 'center', tablet: 'inherit' }}
            px="baseUnit"
            py={{ mobile: 'baseUnit', tablet: '0' }}
          >
            <Link
              to={
                selectedLocale === 'en-us'
                  ? '/'
                  : `/${getLanguageCode(selectedLocale)}`
              }
            >
              <HeaderLogo
                src={logo}
                height={{ mobile: '55px', tablet: '75px' }}
                width="auto"
                alt="QuizRR home"
              />
            </Link>
          </Block>
        </Cell>

        <Cell size={{ mobile: 1, tablet: 1 / 4 }}>
          <Block p="baseUnit" />
        </Cell>

        <Cell size={{ mobile: 1, tablet: 1 / 4 }}>
          <Block p="baseUnit">
            <H5
              color="white"
              textAlign={{ mobile: 'center', tablet: 'left' }}
              mb={{ mobile: '0', tablet: 'baseDown2' }}
            >
              {content.contacts_title}
            </H5>
            <Grid>
              <Cell size={{ mobile: 1, tablet: 5 / 6 }}>
                <Block mb={{ mobile: 'baseUnit', tablet: '0' }}>
                  {(content.contacts &&
                    content.contacts.length &&
                    content.contacts.map(({ title, link }, i) => (
                      <P
                        key={`contact-${link.url}-${i}`}
                        mb="baseDown3"
                        textAlign={{ mobile: 'center', tablet: 'left' }}
                        isBold
                      >
                        <ContactAnchor href={link.url}>{title}</ContactAnchor>
                      </P>
                    ))) ||
                    null}
                </Block>
              </Cell>
              <Cell size={{ mobile: 1, tablet: 1 / 6 }}>
                {(content.social_links &&
                  content.social_links.length &&
                  content.social_links.map((socialLink, i) => (
                    <Block
                      key={`social-link-${socialLink.href.url}-${i}`}
                      mb={
                        i < content.social_links.length - 1 ? 'baseUnit' : '0'
                      }
                      pt={{ mobile: i === 0 ? 'baseUnit' : '0', tablet: '0' }}
                      display="flex"
                      justifyContent="center"
                    >
                      <SocialLinkAnchor href={socialLink.href.url}>
                        <Image content={socialLink.icon} />
                      </SocialLinkAnchor>
                    </Block>
                  ))) ||
                  null}
              </Cell>
            </Grid>
          </Block>
        </Cell>
      </Grid>

      <Grid>
        <Cell size={1}>
          <P
            color="white"
            mb="0"
            fontSize="baseDown1"
            textAlign={{ mobile: 'center', tablet: 'left' }}
          >
            &copy; Quizrr 2022
          </P>
        </Cell>
      </Grid>
    </Block>
  );
};

SiteBottom.propTypes = {
  selectedLocale: PropTypes.string.isRequired,
};

export default SiteBottom;
